import * as types from '../../mutation_types';
import { https } from './http';

const state = {
    company:'',
    mgfrom:'',
    mgto:'',
    mg1from:'',
    mg1to:'',
    mg2from:'',
    mg2to:'',
    mg3from:'',
    mg3to:'',
    mg4from:'',
    mg4to:'',
    mg5from:'',
    mg5to:'',
    phfrom:'',
    phto:'',
    matfrom:'',
    matto:'',
    mats:[],
    page:1,
    currentpage:5,
    loading:false,
    search:'',
    data:{},
    show_mats_modal:false,
    show_mat_range_modal:false
};

const getters = {
    company:state=>state.company,
    mgfrom:state=>state.mgfrom,
    mgto:state=>state.mgto,
    mg1from:state=>state.mg1from,
    mg1to:state=>state.mg1to,
    mg2from:state=>state.mg2from,
    mg2to:state=>state.mg2to,
    mg3from:state=>state.mg3from,
    mg3to:state=>state.mg3to,
    mg4from:state=>state.mg4from,
    mg4to:state=>state.mg4to,
    mg5from:state=>state.mg5from,
    mg5to:state=>state.mg5to,
    phfrom:state=>state.phfrom,
    phto:state=>state.phto,
    matfrom:state=>state.matfrom,
    matto:state=>state.matto,
    mats:state=>state.mats,
    page:state=>state.page,
    currentpage:state=>state.currentpage,
    loading:state=>state.loading,
    search:state=>state.search,
    data:state=>state.data,
    show_mats_modal:state=>state.show_mats_modal,
    show_mat_range_modal:state=>state.show_mat_range_modal
};
const actions = {
    async fetchMara({commit}){
        let uri = `/mara?search=${state.search}&page=${state.page}&currentpage=${state.currentpage}&mgfrom=${state.mgfrom}&mgto=${state.mgto}&mg1from=${state.mg1from}&mg1to=${state.mg1to}
        &mg2from=${state.mg2from}&mg2to=${state.mg2to}&mg3from=${state.mg3from}&mg3to=${state.mg3to}&mg4from=${state.mg4from}&mg4to=${state.mg4to}&mg5from=${state.mg5from}&mg5to=${state.mg5to}
        &phfrom=${state.phfrom}&phto=${state.phto}&matfrom=${state.matfrom}&matto=${state.matto}&mats=${state.mats}&company=${state.company}`;
        await https().get(uri).then(response=>{
            commit(types.MAT_MAS_DATA,response.data);
        }).catch(error=>{
            console.log(error);
        })
    }
};
const mutations = {
    [types.MAT_MAS_DATA](state,data){
        state.data = data;
    },
    [types.MAT_MAS_PAGE](state,data){
        state.page = data;
    },
    [types.MAT_MAS_CURRENTPAGE](state,data){
        state.currentpage = data;
    },
    [types.MAT_MAS_COMPANY](state,data){
        state.company = data;
    },
    [types.MAT_MAS_SEARCH](state,data){
        state.search = data;
    },
    [types.MAT_MAS_LOADING](state){
        state.loading = !state.loading;
    },
    [types.MAT_MAS_MATS_MODAL](state){
        state.show_mats_modal = !state.show_mats_modal;
    },
    [types.MAT_MAS_MAT_RANGE_MODAL](state){
        state.show_mat_range_modal = !state.show_mat_range_modal;
    },
    [types.MAT_MAS_MGFROM](state,data){
        state.mgfrom = data;
    },
    [types.MAT_MAS_MGTO](state,data){
        state.mgto = data;
    },
    [types.MAT_MAS_MG1FROM](state,data){
        state.mg1from = data;
    },
    [types.MAT_MAS_MG1TO](state,data){
        state.mg1to = data;
    },
    [types.MAT_MAS_MG2FROM](state,data){
        state.mg2from = data;
    },
    [types.MAT_MAS_MG2TO](state,data){
        state.mg2to = data;
    },
    [types.MAT_MAS_MG3FROM](state,data){
        state.mg3from = data;
    },
    [types.MAT_MAS_MG3TO](state,data){
        state.mg3to = data;
    },
    [types.MAT_MAS_MG4FROM](state,data){
        state.mg4from = data;
    },
    [types.MAT_MAS_MG4TO](state,data){
        state.mg4to = data;
    },
    [types.MAT_MAS_MG5FROM](state,data){
        state.mg5from = data;
    },
    [types.MAT_MAS_MG5TO](state,data){
        state.mg5to = data;
    },
    [types.MAT_MAS_MATS](state,data){
        state.mats = data;
    },
    [types.MAT_MAS_MATFROM](state,data){
        state.matfrom = data;
    },
    [types.MAT_MAS_MATTO](state,data){
        state.matto = data;
    },
    [types.MAT_MAS_PHFROM](state,data){
        state.phfrom = data;
    },
    [types.MAT_MAS_PHTO](state,data){
        state.phto = data;
    }
};

export {
    state,getters,actions,mutations
}